<template>
  <el-dialog :title="$t('message.batchDispatchInspector')" :visible.sync="dialogVisible" width="520px"
    :close-on-click-modal="false" :close-on-press-escape="!submitting" :show-close="!submitting" center>
    <div class="admin-select">
      <span>{{ $t('message.personnelSelection') }}：</span>
      <el-select v-model="inspectorId" :placeholder="$t('message.inspector')" :disabled="submitting"
        filterable clearable>
        <el-option v-for="item in inspectorList" :key="item.id" :label="item.realname" :value="item.id" />
      </el-select>
    </div>

    <!-- 后端按单个检品单调配，批量执行时展示当前处理进度。 -->
    <div class="dispatch-progress" v-if="submitting || progress.total">
      <p>{{ $t('message.inspectionDispatchProgress') }}：{{ progress.current }}/{{ progress.total }}</p>
      <el-progress :percentage="progressPercentage" />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button :disabled="submitting" @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">{{ $t('message.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      inspectorId: '',
      inspectionOrders: [],
      progress: {
        current: 0,
        total: 0,
        failed: 0,
      },
    }
  },
  computed: {
    inspectorList() {
      return this.$store.state.authWorkGroupAdmin.j.filter(item => item.forbid_login == 0)
    },
    progressPercentage() {
      if (!this.progress.total) return 0
      return Math.round(this.progress.current / this.progress.total * 100)
    },
  },
  methods: {
    // 父页面传入已勾选的检品单，组件负责逐单调用现有调配接口。
    open(inspectionOrders) {
      this.inspectionOrders = [...inspectionOrders]
      this.inspectorId = ''
      this.progress = { current: 0, total: 0, failed: 0 }
      this.dialogVisible = true
    },
    async submit() {
      if (!this.inspectorId) return this.$message.warning(this.$t('message.personnelSelection'))

      this.submitting = true
      this.progress = {
        current: 0,
        total: this.inspectionOrders.length,
        failed: 0,
      }

      // 任意一单返回失败或发生网络异常，都立即停止后续调配。
      for (const item of this.inspectionOrders) {
        let isFailed = false
        try {
          const res = await this.$api.inspectionApi.inspectDispatchAdmin({
            inspect_sn: item.inspect_sn,
            j_id: this.inspectorId,
          }, {
            isLoading: true, // 关闭全屏 Loading，避免遮挡组件内进度条。
            resolveError: true, // 业务失败也返回结果，由组件统一停止并刷新。
          })
          isFailed = res.code != 0
        } catch (error) {
          isFailed = true
        } finally {
          this.progress.current += 1
        }

        if (isFailed) {
          this.progress.failed += 1
          break
        }
      }

      this.submitting = false
      this.dialogVisible = false
      if (this.progress.failed) {
        this.$message.warning(this.$t('message.inspectionDispatchFailed'))
      } else {
        this.$message.success(this.$t('message.inspectionDispatchSuccess'))
      }
      // 全部成功或中途失败都刷新父页面，确保列表展示最新调配结果。
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="scss" scoped>
.admin-select {
  display: flex;
  align-items: center;
  padding: 0 30px;

  span {
    width: 100px;
  }

  .el-select {
    flex: 1;
  }
}

.dispatch-progress {
  margin-top: 24px;
  padding: 0 30px;

  p {
    margin-bottom: 10px;
  }
}
</style>
